var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('p',{staticClass:"btn"},[_c('span',[_vm._v("首页")]),_vm._v("\n        >\n        "),_c('span',[_vm._v(_vm._s((_vm.checkedTagType=='1'?'待接诊':
                _vm.checkedTagType=='2'?'已接诊':
                _vm.checkedTagType=='3'?'已结诊':
                _vm.checkedTagType=='4'?'未结诊':''
                )))]),_vm._v("\n        >\n        "),_c('span',[_vm._v(_vm._s((
                _vm.checkedTagKey=='1'?'预约信息':
                _vm.checkedTagKey=='2'?'病历':
                _vm.checkedTagKey=='3'?'处方':
                _vm.checkedTagKey=='4'?'检查':
                _vm.checkedTagKey=='5'?'检验':''
                )))])]),_vm._v(" "),_c('p',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.NoCopyright),expression:"NoCopyright"}]},[_vm._v("技术支持：北京天桃科技有限公司")]),_vm._v(" "),_c('span',[_vm._v("版本号：1.0.1")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7437498","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/private_consultation_page/fun_right/breadcrumb/index.vue
// module id = null
// module chunks = 